import React from 'react';

import { widgetStyle } from '../../../styles/constants';
import { Button } from '../Button';

/**
 * Props for the Error component
 */
export interface ErrorProps {
  /** Error message to display */
  text: string;
  /** Callback function when back button is clicked */
  onBack: () => void;
}

/**
 * Error Component - Display error messages with back navigation
 *
 * A standardized error display component that shows error messages
 * in a consistent format with a back button for navigation.
 *
 * @example
 * <Error
 *   text="Connection failed. Please try again."
 *   onBack={() => setError(null)}
 * />
 */
export const Error: React.FC<ErrorProps> = ({ text, onBack }) => {
  return (
    <div>
      <p>Information</p>
      <hr />
      <div style={widgetStyle}>{text}</div>
      <hr />
      <Button text="Back" onClick={onBack} />
    </div>
  );
};

export default Error;
